import { LazyAppModals } from "@faire/retailer/components/App/AppModals";
import { preload } from "./__internal__/preload";
var preloadAppModals = function() {
    preload(LazyAppModals);
};
export default preloadAppModals;
